// extracted by mini-css-extract-plugin
module.exports = {"tech":"About_tech__1DCYL"};